import React, { useEffect, useRef } from "react";
import { Form, Input } from "antd";

const { TextArea } = Input;
const { Item } = Form;

const InputTextArea = (props) => {
  const {
    id,
    placeholder,
    name,
    label,
    required,
    value,
    className,
    rowNumbers,
    onChangeHandler,
    disabled = false,
    focus,
  } = props;

  const myRef = useRef(className || "");

  useEffect(() => {
    if (focus) myRef.current.focus();
  }, [focus]);

  return (
    <div className="text-area-input" key={id}>
      <Item
        key={id}
        name={name}
        label={label}
        rules={[
          {
            required: required,
          },
        ]}
        className={`${className} text-area-field`}
      >
        <TextArea
          id={label + "textArea"}
          rows={rowNumbers}
          placeholder={placeholder}
          onChange={(e) => onChangeHandler(e.target.value, id)}
          value={value || ""}
          suffix={<p>Image</p>}
          disabled={disabled}
          ref={myRef}
        />
      </Item>
    </div>
  );
};

export default InputTextArea;
